import { render, staticRenderFns } from "./ServicesEdit.vue?vue&type=template&id=0d3aad7c"
import script from "./ServicesEdit.vue?vue&type=script&lang=ts"
export * from "./ServicesEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports